"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.massShifts = massShifts;
const ml_regression_theil_sen_1 = require("ml-regression-theil-sen");
const ml_spectra_processing_1 = require("ml-spectra-processing");
/**
 * Calculates a function that allows post-calibration on mass spectra based on the error in assignment
 * @param {*} similarities
 * @param {object} [options={}]
 * @returns
 */
function massShifts(similarities, options = {}) {
    const { minSimilarity = 0.95, minLength = 10 } = options;
    let results = [];
    if (!Array.isArray(similarities)) {
        for (let key of results) {
            for (let entry of results[key]) {
                results.push(entry);
            }
        }
    }
    else {
        results = similarities;
    }
    results = results.filter((result) => result.ms &&
        result.ms.similarity &&
        result.ms.similarity.value > minSimilarity);
    if (results.length < minLength) {
        throw new Error(`X rescale can not be applied. We need at least ${minLength} peaks with over ${Math.round(minSimilarity * 100)}% similarity`);
    }
    const data = results
        .map((result) => {
        return {
            em: result.ms.em,
            delta: result.ms.delta,
        };
    })
        .toSorted((a, b) => a.em - b.em);
    let shifts = { x: [], y: [] };
    for (const datum of data) {
        shifts.x.push(Number(datum.em));
        shifts.y.push(Number(datum.delta));
    }
    const regression = new ml_regression_theil_sen_1.TheilSenRegression(shifts.x, shifts.y);
    let minX = (0, ml_spectra_processing_1.xMinValue)(shifts.x);
    let maxX = (0, ml_spectra_processing_1.xMaxValue)(shifts.x);
    let shiftsPPM = { x: shifts.x, y: [] };
    for (const datum of data) {
        shiftsPPM.y.push(Number((datum.delta / datum.em) * 1e6));
    }
    let regressionChart = { x: [], y: [] };
    for (let i = minX; i < maxX; i += (maxX - minX) / 1000) {
        regressionChart.x.push(i);
        regressionChart.y.push(regression.predict(i));
    }
    return {
        shifts,
        shiftsPPM,
        fit: regressionChart,
        score: regression.score(shifts.x, shifts.y),
        predictFct: regression.predict.bind(regression),
        tex: regression.toLaTeX(3),
        slope: regression.slope,
        intercept: regression.intercept,
        predictFctString: `${regression.slope} * mass + ${regression.intercept}`,
    };
}
//# sourceMappingURL=massShifts.js.map